<template>
    <div class="calandar-content">
        <div class="calandar-row">
            <div class="top-item top-item-left" @click="prveClick">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="top-item">{{`${year}-${month}`}}</div>
            <div class="top-item top-item-right" @click="nextClick">
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
        <div class="calandar-row">
            <div class="calandar-item">日</div>
            <div class="calandar-item">一</div>
            <div class="calandar-item">二</div>
            <div class="calandar-item">三</div>
            <div class="calandar-item">四</div>
            <div class="calandar-item">五</div>
            <div class="calandar-item">六</div>
        </div>
        <div class="calandar-row" v-for="(row,key,index) in item" :key="index">
            <template v-for="(it,i) in row">
                <div class="calandar-item cur-p"
                     @click="itemClick(it)"
                     v-if="it.mother === month"
                     :class="{
                     'color-gray': it.status === 1,
                     'cur-no': it.status === 1,
                     'active':it.mother === currentMonth && it.year === currentYear && it.num === currentDay && !multiple,
                     'active':dataAry.includes(`${it.year}-${it.mother}-${it.num}`),
                 }"
                     :key="i">
                    <div>{{it.num}}</div>
                    <div v-if="!it.states && type === 1" class="color-red">不可用</div>
                    <div v-if="type!==1 && it.status === 2" class="color-red">不可用</div>
                </div>
                <div v-else class="calandar-item"></div>
            </template>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Calendar",
        props: {
            type: {
                type: Number,
                default: 1
            },
            multiple:{
                type: Boolean,
                default: false
            },
            item: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        data() {
            return {
                year: '',
                month: '',
                currentYear: '',
                currentMonth: '',
                currentDay: '',
                dataAry: []
            }
        },
        created() {
            let now = new Date();
            this.year = now.getFullYear();
            this.month = now.getMonth() + 1;
        },
        methods: {
            prveClick() {
                if (this.month > 1) {
                    this.month--
                } else {
                    this.year--;
                    this.month = 12;
                }
                this.$emit('change', {year: this.year, month: this.month})
            },
            nextClick() {
                if (this.month < 12) {
                    this.month++
                } else {
                    this.year++;
                    this.month = 1;
                }
                this.$emit('change', {year: this.year, month: this.month})
            },
            itemClick(item) {
                this.currentYear = item.year;
                this.currentMonth = item.mother;
                this.currentDay = item.num;
                if(this.multiple){
                    if(item.status === 1) return;
                    let str = `${item.year}-${item.mother}-${item.num}`
                    let index = this.dataAry.indexOf(str)
                    if(index>=0){
                        this.dataAry.splice(index,1)
                    }else {
                        this.dataAry.push(str)
                    }
                    this.$emit('select', this.dataAry)
                }else {
                    this.$emit('select', {
                        year: this.currentYear,
                        month: this.currentMonth,
                        day: this.currentDay
                    })
                }
            },
            clear(){
                this.dataAry = []
            }
        },
    }
</script>

<style scoped lang="less">
    .calandar-content {
        width: 350px;
        border: 1px solid #e2e2e2;

        .calandar-row {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #e2e2e2;

            &:last-child {
                border-bottom: none;
            }

            .calandar-item {
                width: 50px;
                height: 50px;
                border-right: 1px solid #e2e2e2;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-flow: column;
                line-height: 1.2;

                &:last-child {
                    border-right: none;
                }
            }

            .top-item {
                flex: 1;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }

    .top-item-left {
        cursor: pointer;

        &:hover {
            .el-icon-arrow-left {
                color: #e44646;
            }
        }
    }

    .top-item-right {
        cursor: pointer;

        &:hover {
            .el-icon-arrow-right {
                color: #e44646;
            }
        }
    }

    .active {
        background-color: #6cf !important;
        color: #ffffff !important;
    }
    .cur-no{
        cursor: not-allowed !important;
    }
</style>
